import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { actions } from "venuescanner-js/constants/leads";

import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import observableToUseEffect from "venuescanner-js/react/components/Inbox/utils/observableToUseEffect";
import formatNumber from "venuescanner-js/helpers/formatNumber";
import { leadStatus } from "venuescanner-js/constants/thread";
import countries from "venuescanner-js/constants/countries.json";

import LeadAccept from "venuescanner-js/react/components/Inbox/components/Leads/LeadAccept";
import LeadStatusPopup from "venuescanner-js/react/components/Inbox/components/Leads/LeadStatusPopup";
import LeadIgnore from "venuescanner-js/react/components/Inbox/components/Leads/LeadIgnore";
import moment from "moment";

const Lead = ({ lead, activeFilter }) => {
  const { isMobileDevice } = useContext(ViewContext);
  const [leadData, setLeadData] = useState(null);
  const [leadCurrency, setLeadCurrency] = useState(null);
  const [leadCta, setLeadCta] = useState(null);
  let history = useHistory();
  let { url } = useRouteMatch();
  const searchParamStatus = new URLSearchParams(useLocation().search).get(
    "status"
  );

  useEffect(() => {
    return observableToUseEffect({ lead }, ({ lead }) => setLeadData(lead));
  }, [lead]);

  const getLeadCta = (status) => {
    switch (status) {
      case leadStatus.OPEN:
        return setLeadCta(
          <div className="lead__cta">
            <span className="lead__cta__button lead__cta__button--accept">
              More info
            </span>
          </div>
        );
      case leadStatus.INTERESTED:
        return setLeadCta(
          <span className="lead__cta__status lead__cta__status--pending">
            Pending
          </span>
        );
      case leadStatus.NOT_INTERESTED:
        return setLeadCta(
          <span className="lead__cta__status lead__cta__status--ignored">
            Ignored
          </span>
        );
      case leadStatus.ACCEPTED:
        return setLeadCta(
          <span className="lead__cta__status lead__cta__status--accepted">
            Enquiry made
          </span>
        );
      case leadStatus.ACCEPTED_ORGANICALLY:
        return setLeadCta(
          <span className="lead__cta__status lead__cta__status--accepted-organically">
            Enquiry Made
          </span>
        );
      case leadStatus.EXPIRED:
        return setLeadCta(
          <span className="lead__cta__status lead__cta__status--missed">
            Missed
          </span>
        );
      default:
        return null;
    }
  };

  const getLockedLeadCta = (venue) => {
    if (venue?.enquiries?.locked)
      setLeadCta(
        <a
          href="/subscription-upgrade"
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          className="lead__cta__button lead__cta__button--freemium-over"
        >
          Upgrade to action
        </a>
      );
  };

  useEffect(() => {
    if (leadData?.lead?.status) {
      if (
        leadData?.venue?.enquiries?.locked &&
        leadData?.lead?.status === leadStatus.OPEN
      ) {
        getLockedLeadCta(leadData?.venue);
      } else {
        getLeadCta(leadData.lead.status);
      }
      setLeadCurrency(countries[leadData?.venue?.country_code || "GB"]);
    }
  }, [leadData]);

  if (!leadData || !leadCurrency) return null;

  const openLead = () => {
    if (leadData?.venue?.enquiries?.locked) {
      history.push(`/inbox/leads/${leadData._id}`);
    } else {
      if (leadData.lead.status === leadStatus.OPEN) {
        history.push(
          `/inbox/leads/${leadData._id}?status=${actions.ACCEPT.search_param}`
        );
      } else {
        history.push(`/inbox/leads/${leadData._id}`);
      }
    }
  };

  return (
    <div
      className={
        activeFilter.name === "all" ||
        activeFilter.status === leadData.lead.status
          ? "leads__list__row"
          : "leads__list__row hide"
      }
      onClick={() => openLead()}
    >
      <span className="p venue-name">{leadData.venue.name}</span>
      <span className="p event-type">
        {leadData.admin_event?.event_type || "-"}
      </span>
      <span className="p date">
        {leadData?.lead?.event_date
          ? moment(leadData.lead.event_date).format("DD/MM/YYYY")
          : "-"}
      </span>
      {leadData.admin_event.budget ? (
        <span className="p budget">
          {leadCurrency.currency.symbol +
            formatNumber(leadData.admin_event.budget)}
        </span>
      ) : (
        <span className="p budget">-</span>
      )}
      <div className="p ctas">{leadCta}</div>
      {url === `/inbox/leads/${leadData._id}` && (
        <>
          {searchParamStatus === actions.ACCEPT.search_param ? (
            <LeadAccept lead={leadData} leadCurrency={leadCurrency} />
          ) : searchParamStatus === actions.IGNORE.search_param ? (
            <LeadIgnore lead={leadData} />
          ) : (
            <LeadStatusPopup lead={leadData} leadCurrency={leadCurrency} />
          )}
        </>
      )}
    </div>
  );
};

export default Lead;
